var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCornerChatBubbles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 142,
    viewBox: "0 0 140 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.241 73.3667V97.4475C92.241 99.5775 92.0043 101.589 91.4718 103.423C89.2827 112.121 82.0643 117.564 72.1243 117.564H56.031L38.1627 129.457C35.5002 131.291 31.9502 129.338 31.9502 126.143V117.564C25.9152 117.564 20.886 115.553 17.3952 112.062C13.8452 108.512 11.8335 103.482 11.8335 97.4475V73.3667C11.8335 62.125 18.8152 54.3742 29.5835 53.3683C30.3527 53.3092 31.1218 53.25 31.9502 53.25H72.1243C84.1943 53.25 92.241 61.2967 92.241 73.3667Z",
    fill: "#FFE2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.021 92.3002C112.535 92.3002 118.866 89.8152 123.244 85.3777C127.682 80.9993 130.167 74.6685 130.167 67.1543V36.9793C130.167 23.0752 118.925 11.8335 105.021 11.8335H54.7293C40.8252 11.8335 29.5835 23.0752 29.5835 36.9793V41.4168C29.5835 43.0735 30.8852 44.3752 32.5418 44.3752H72.1243C88.1585 44.3752 101.116 57.3327 101.116 73.3668V89.3418C101.116 90.9985 102.418 92.3002 104.074 92.3002H105.021Z",
    fill: "#DDE6EB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.2454,
    cy: 85.7357,
    r: 4.01887,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.6414,
    cy: 85.7357,
    r: 4.01887,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.8489,
    cy: 85.7357,
    r: 4.01887,
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCornerChatBubbles);
export default ForwardRef;